export default {
  users: [],
  supervisorOptions: [],
  usersContext: '',
  hierarchies: [],
  locations: [],
  positions: []
};
